import './spinner-style.scss';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  className?: string;
  'aria-label'?: string;
}

export const Spinner = ({
  size = 'medium',
  className = '',
  'aria-label': ariaLabel = 'Loading',
}: SpinnerProps) => {
  return (
    <div
      className={`spinner spinner-${size} ${className}`}
      aria-label={ariaLabel}
      role="status"
    >
      <span className="sr-only">{ariaLabel}</span>
    </div>
  );
};
